<div class="wrapper d-flex flex-column align-items-center h-100 w-100">
	<h2 class="title">Refresh data</h2>

	<img class="mb-2" ngSrc="/assets/icons/yellow-warning-sign.svg" alt="warning icon" width="37" height="37" />

	<p class="text text-center">
		This action can take up to 15 minutes to complete. Please note: your AWS cost explorer billing will be charged by up
		to {{ (potentialSavings$ | async)?.ceCallsCost }} for this action.
	</p>

	<div class="mt-auto d-flex justify-content-center align-items-center">
		<button type="button" class="btn btn-cancel mr-2" (click)="cancelAction()">Cancel</button>
		<button type="button" class="btn btn-confirm" (click)="refresh()">Confirm</button>
	</div>
</div>
